import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";

export const typeDef = gql`
  type InformarionConnection {
    data: [Link]
    pageInfo: PageInfo
  }
  type Query {
    informations(key: String, offset: Int, limit: Int): InformarionConnection
  }
`;

export const resolvers = {
  Query: {
    informations: async (_parent, { key, offset, limit }, { dataSources }) => {
      const res = await dataSources.linkSet.linkSet(key, offset, limit);
      return {
        data: res?.links,
        pageInfo: createPageInfo({ offset, limit, count: res.total_count }),
      };
    },
  },
};
